import { useEffect, useRef, useState } from 'react';
import styles from './Mitigations.module.scss';
import { Text } from '../../components/typography';
import Icon from '../../components/Icon';
import { Form } from 'react-bootstrap';
import { customColors } from '../../utilities';

export default function MitigationCard({
  title,
  onEdit = () => {},
  isEditing,
  selected,
  onDelete = () => {},
  backgroundColor = customColors.BLUE_LIGHT,
  count,
}) {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const inputRef = useRef(null);

  useEffect(() => {
    setNewTitle(title);
  }, [title]);

  const handleBlur = (e) => {
    e.stopPropagation();
    setIsEditingTitle(false);
    onEdit(newTitle);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div
      className={selected ? styles.deleted : styles.card}
      style={{ border: `2px solid ${backgroundColor}` }}
    >
      {isEditingTitle ? (
        <Form.Control
          value={newTitle}
          as="textarea"
          rows={2}
          onChange={(e) => setNewTitle(e.target.value)}
          onBlur={handleBlur}
          ref={inputRef}
        />
      ) : (
        <Text noMargin size="sm">
          {newTitle}{' '}
          <span className={styles.span}>
            {!!count && count > 1 ? ` (${count})` : ''}
          </span>
        </Text>
      )}
      {isEditing && (
        <div className={styles.flexRow}>
          <Icon
            color={isEditingTitle ? 'green' : 'secondary'}
            style={{ fontSize: '1rem' }}
            onClick={() => {
              onEdit(newTitle);
              setIsEditingTitle(!isEditingTitle);
            }}
          >
            {isEditingTitle ? 'check' : 'edit'}
          </Icon>
          <Icon
            onClick={() => {
              onDelete();
            }}
            color="red"
            style={{ fontSize: selected ? '1.5rem' : '1rem' }}
          >
            {selected ? 'close' : 'delete'}
          </Icon>
        </div>
      )}
    </div>
  );
}
